export default __webpack_public_path__ + "static/media/team_aqmal.3a04bd8f.png";